export var formatAddress = function (addressObject, showZip, showCityAndState, showState) {
    if (showZip === void 0) { showZip = true; }
    if (showCityAndState === void 0) { showCityAndState = true; }
    if (showState === void 0) { showState = true; }
    var box = addressObject.box, houseNumber = addressObject.number, city = addressObject.city, state = addressObject.state, street = addressObject.street, zip = addressObject.zip, _a = addressObject.country, country = _a === void 0 ? "" : _a;
    // Street info
    var streetInfoComponents = [];
    if (street)
        streetInfoComponents.push(street);
    if (street && houseNumber)
        streetInfoComponents.push(houseNumber);
    if (street && houseNumber && box)
        streetInfoComponents.push(box);
    var streetInfo = streetInfoComponents.join(" ");
    // City info
    var cityInfoComponent = [];
    if (showZip && zip)
        cityInfoComponent.push(zip);
    if (showCityAndState && city)
        cityInfoComponent.push(city);
    if (showCityAndState && showState && state && country !== "BE")
        cityInfoComponent.push(state);
    var cityInfo = cityInfoComponent.join(" ");
    // Return
    if (streetInfo.length && cityInfo.length) {
        return streetInfo + ", " + cityInfo;
    }
    if (streetInfo.length) {
        return streetInfo;
    }
    if (cityInfo.length) {
        return cityInfo;
    }
    return "";
};
export var isValidAddress = function (addressObject) {
    if (!addressObject) {
        return false;
    }
    return (addressObject.street &&
        addressObject.street.length > 0 &&
        addressObject.number &&
        addressObject.number.length > 0 &&
        addressObject.zip &&
        addressObject.zip.length > 0 &&
        addressObject.city &&
        addressObject.city.length > 0 &&
        addressObject.country &&
        addressObject.country.length > 0);
};
